function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.243 4.913L8.564 9.81v9.842L.243 14.756V4.913z",
  fill: "#D1DAE2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M.243 4.913L8.564 9.81v9.842L.243 14.755V4.913z",
  fill: "url(#disabled_svg__paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.885 4.913L8.564 9.81v9.842l8.321-4.897V4.913z",
  fill: "#D1DAE2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M16.885 4.913L8.564 9.81v9.842l8.321-4.897V4.913z",
  fill: "url(#disabled_svg__paint1_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.564 0l8.322 4.913-8.322 4.913L.243 4.913 8.564 0z",
  fill: "#D1DAE2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M8.564 0l8.321 4.913-8.321 4.913L.243 4.913 8.564 0z",
  fill: "url(#disabled_svg__paint2_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "disabled_svg__paint0_linear",
  x1: 8.564,
  y1: 9.55,
  x2: -1.007,
  y2: 14.791,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "disabled_svg__paint1_linear",
  x1: 18.398,
  y1: 2.082,
  x2: 9.571,
  y2: 19.866,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "disabled_svg__paint2_linear",
  x1: 16.885,
  y1: 6.452,
  x2: -0.823,
  y2: 10.268,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray"
})));

var SvgDisabled = function SvgDisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disabled.658ebda3.svg";
export { ForwardRef as ReactComponent };